import React, { useState, useEffect } from 'react';
import { deleteProductUnit } from '../Helpers/deleteProductUnit';
import { getQuantity } from '../Helpers/getQuantity';
import { getPrice } from '../Helpers/getPrice';
import { useDispatch } from 'react-redux';
import { getNumProds } from '../Helpers/getNumProds';
import { simpleAction } from '../Redux/actions/simpleAction';
import { addProductUnit } from '../Helpers/addProductUnit';
import { deleteProduct } from '../Helpers/deleteProduct';

const ListedProd = props =>{
    const [ quantity, setQuantity ] = useState(1);
    const [ price, setPrice ] = useState(0);
    const dispatch = useDispatch();

    useEffect(()=>{
        getQuantity(props.nombre, setQuantity);
        getPrice(props.nombre, setPrice);
    })
    return(
        <div className="listedProd">
            <p className="productName">{props.nombre}</p>
            <div className="prodPanel">
                {
                    quantity > 0 &&
                    <button className="minus" onClick={()=>{deleteProductUnit(props.nombre); getQuantity(props.nombre, setQuantity); getPrice(props.nombre, setPrice); getNumProds(dispatch, simpleAction); deleteProduct(props.nombre)}}>-</button>
                }
                <p className="productQuant">{quantity}</p>
                <button className="plus" onClick={()=>{addProductUnit(props.nombre); getQuantity(props.nombre, setQuantity); getPrice(props.nombre, setPrice); getNumProds(dispatch, simpleAction)}}>+</button>
            </div>
            <div className="totalProduct">{price.toFixed(2)} €</div>
        </div>
    )
}

export default ListedProd;